import { Card, CardBody, CardHeader, Col, Container, Row, Table, } from "reactstrap";
import { Image, Badges, Btn, H4, H6 } from "../../AbstractElements";
import { convertAmountToWordsGNF, URL_API } from "../../utils/helper/helpers";
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { formatPhoneNumber, formatPrice, generateRandomNumber, numberToWords } from "../../utils/helper/helpers";

import { Link, useParams } from "react-router-dom";
import html2pdf from "html2pdf.js";

// Types
type Factures = { [key: string]: any }
interface FacturesInterfaces {
    [key: string]: any;
}

const ShowFactures = () => {

    const [factures, setFactures] = useState<Factures | null>(null);
    const [details, setDetails] = useState<FacturesInterfaces[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [refresh, setRefresh] = useState(false);
    const params = useParams();
    const Token = JSON.parse(localStorage.getItem("login")!);

    // Fetch data from API
    const fetchFactures = useCallback(async () => {
        try {
            const response = await axios.get(`${URL_API}/factures/show/${params.id}`, {
                headers: { Authorization: `Bearer ${Token}` }
            });
            if (response.status === 200) {
                setFactures(response.data.factures);
                setDetails(response.data.details)

            }
        } catch (error: any) {
            const message = error.response?.data?.message || "Erreur inconnue";
            toast.error(message);
        }
    }, []);

    // Initial data fetch
    useEffect(() => {
        fetchFactures();
        setTimeout(() => {
            if ( factures && factures?.length > 0) {
                setIsLoading(false); // Les données sont chargées, on arrête le loader
              } else {
                setIsLoading(false);
              }
          }, 2000);
    }, [refresh, fetchFactures]);

    const documentContent = (
        <>
            <h2>Mon Document PDF</h2>
            <p>Ceci est un exemple de document PDF généré avec React et html2pdf.js.</p>
            {/* Ajoutez plus de contenu ici selon vos besoins */}
        </>
    );

    const pdfRef = useRef<HTMLDivElement>(null);

    const generatePDF = () => {
        const element = pdfRef.current;
        const name_document = generateRandomNumber(100000, 999999);
        if (element) {
            html2pdf()
                .from(element)
                .save(`bon_Factures_${name_document}.pdf`);
        }
    };


    return (
        <div className='page-body'>
            {isLoading ? (
                <div className="loading-container">
                    <div className="spinner-container">
                        <div className="spinner"></div>
                        <span className="loading-text">Chargement de la plateforme...</span>
                    </div>
                </div>
            ) : ( 
                <>
                    <Breadcrumbs mainTitle="Factures Details" parent="Factures" />
                    <Container fluid>
                        <Card>
                            <CardBody>
                                <div ref={pdfRef}>
                                    <div className="text-center mb-5 mt-5">
                                        <p dangerouslySetInnerHTML={{ __html: factures?.ets_description }}></p>

                                    </div>
                                    <Row className="mx-3 m-4">
                                        <Col lg={6}>
                                            <h2 className="fw-bold text-center"> FACTURE D'ACHAT</h2>
                                            <h3 className="text-danger mt-3 text-center f-18 fw-lighter text-uppercase" style={{ fontFamily: 'Courier' }}>#{factures?.num}</h3>
                                        </Col>
                                        <Col lg={6} className="text-center">
                                            <h2 className=" fw-lighter f-18">Date d'Émission</h2>
                                            {
                                                factures?.status === "payed" ? (
                                                    <h3 className="text-success my-2 f-18 fw-lighter text-uppercase" style={{ fontFamily: 'Courier' }}>{factures?.date_facture}</h3>
                                                ) : (
                                                    <h3 className="text-danger my-2 f-18 fw-lighter text-uppercase" style={{ fontFamily: 'Courier' }}>{factures?.date_facture}</h3>
                                                )
                                            }
                                        </Col>

                                    </Row>
                                    <p className="f-18 mx-3"><span className="fw-bold">Clients </span>: {factures?.client}</p>
                                    <div className="mx-3 mt-3">
                                        <Table bordered responsive className="text-center">
                                            <thead>
                                                <tr className="f-18">
                                                    <th scope="col">No</th>
                                                    <th scope="col">DESIGNATION</th>
                                                    <th scope="col">QUANTITE</th>
                                                    <th scope="col">P. UNITAIRE</th>
                                                    <th scope="col">MONTANT</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    details.map((item, index) => (
                                                        <tr className="f-18" key={index}>
                                                            <td>#{index + 1}</td>
                                                            <td>{item.designation}</td>
                                                            <td>{item.quantite}</td>
                                                            <td>{formatPrice(item.prix_unitaire)}</td>
                                                            <td>{formatPrice(item.prix_unitaire * item.quantite)}</td>
                                                        </tr>
                                                    ))
                                                }
                                                <tr>
                                                    <td colSpan={4} className="bg-light-info">
                                                        <span className="f-18 fw-bold">TOTAL</span>
                                                    </td>
                                                    <td className="f-18 fw-bold">{formatPrice(factures?.total)}</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                        <Row className="pt-3">
                                            <Col>
                                                <H6 className="fw-bold">PAYÉ : {formatPrice(factures?.payer)}</H6>
                                            </Col>
                                            <Col>
                                                <H6 className="fw-bold">RESTE À PAYER : {formatPrice(factures?.restapayer)}</H6>
                                            </Col>
                                            <Col sm={12} className="pt-3">
                                                <span className="fw-bold">Arrêter la présente facture à la somme de : </span> <span className="text-capitalize">{convertAmountToWordsGNF(factures?.total)}</span>
                                            </Col>
                                        </Row>
                                        <Row className="pt-3">
                                            <Col>
                                                <H4 className="text-center">Clients</H4>
                                            </Col>
                                            <Col>
                                                <H4 className="text-center">Gérant</H4>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>

                                <div className="text-center">
                                    <Btn color="light-info " onClick={generatePDF} className="btn btn-xs mx-1 p-1 px-3">
                                        <i className="fa fa-download"></i> Télécharger
                                    </Btn>
                                    <Link to="/factures" className="btn btn-xs mx-1 p-1 px-3 btn-light-danger">
                                        <i className="fa fa-sign-out"></i> Quitter
                                    </Link>
                                </div>
                            </CardBody>
                        </Card>
                    </Container>
                </>
            )}
            
        </div >

    )
}

export default ShowFactures;